import * as React from "react";
import { Notifications as MantineNotifications } from "@mantine/notifications";
import styled, { css } from "styled-components";
import zIndices from "theme/z-indices";
const StyledNotifications = styled(MantineNotifications)(
  ({ theme }) => css`
    .mantine-Notification-root {
      background-color: ${theme.colors.global.contentBackground};
      border-radius: 4px;
      box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
      border: 1px solid ${theme.colors.variant.default};
    }

    .mantine-Notification-title {
      font-weight: bold;
    }

    .mantine-Notification-description {
      color: ${theme.colors.gray[10]};
    }
  `
);
const Notifications = () => /* @__PURE__ */ React.createElement(StyledNotifications, { zIndex: zIndices.notifications });
export default Notifications;
